import { CDN_BASE_URL } from "config";
import React from "react";
import { FaBed, FaMapLocation, FaUser } from "react-icons/fa6";
import { Link } from "react-router-dom";

const CategoryCard = ({ data, t, prev, i18 }) => {
  return (
    <Link
      to={`/category/${prev}/${data?.url}`}
      className="block "
    >
      <div className="flex flex-col gap-2  bg-white shadow border  rounded-[12px] h-[110px] w-[110px] md:w-[150px] md:h-[150px]">
        <img
          src={CDN_BASE_URL + data?.img}
          className="w-full object-contain p-2 h-full"
          alt="Product"
        />
      </div>
      <h3 className="font-bold text-[16px] lg:text-[18px] mt-3 text-center text-black">
        {data?.[`name_${i18.language}`] || data?.name}
      </h3>
    </Link>
  );
};

export default CategoryCard;
